import { DbEntity } from './DbEntity';
import { StatementLink } from './StatementLink';

export class StatementCategoryModel implements DbEntity
{
	public Id: string = '';
	public Name: string = '';
	public LinkNK: StatementLink = new StatementLink();
	public OrderText: string = '';
	public LinkOrder: StatementLink = new StatementLink();
	public FileTypes: string[] = [];
}
